module.exports = __webpack_public_path__ + "static/1-7a569bc299d79b6f605232d0bfcb0629.jpg";